import { useState, useRef } from 'react'
import { Form as FinalForm, FormRenderProps } from 'react-final-form'
import Grid from '@material-ui/core/Grid'
import MyTextfield from '../../../control/textfield/textfield'
import useTranslate from '../../../i18n/useTranslate'
import usePreferencePasscode, { FormProps, ChangePasscodeProps } from '../../../services/um/usePreferencePasscode'
import useAuthenStore from '../../../stores/authen/authenStore'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import IconButton from '@material-ui/core/IconButton'
import Dialog, { DialogType } from '../../../control/dialog/dialog'

type FormComponentProps = {
    onRefFormProps?: (func: FormRenderProps) => void
    onRefCloseDialog: () => void
    isPasscode: boolean
}
const Form = (props: FormComponentProps) => {
    const { onRefFormProps, onRefCloseDialog, isPasscode } = props
    const t = useTranslate()
    const authenStore = useAuthenStore()
    const preferencePasscodeHook = usePreferencePasscode()

    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogTwoRef = useRef<Record<string, Function>>()

    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const [displayPW, setDisplayPW] = useState({
        passcode: false,
        confirmPasscode: false,
    })

    const validateForm = (values: FormProps) => {
        const errors: any = {}
        if (isPasscode && !values.passcode) {
            errors.passcode = t.get('MESSAGE.M023')
        }
        if (!values.newPasscode) {
            errors.newPasscode = t.get('MESSAGE.M023')
        }
        if (values.newPasscode !== values.confirmNewPasscode) {
            errors.confirmNewPasscode = t.get('MESSAGE.M019')
        }

        return errors
    }

    const handleSubmitForm = async (value: FormProps) => {
        const param: ChangePasscodeProps = {
            userId: authenStore.profile.userId ?? 0,
            passcode: value.passcode,
            newPasscode: value.newPasscode,
        }
        const result = await preferencePasscodeHook.putPreferencesChangePasscode(param)
        if (result.message === 'success') {
            setConfigDialog({
                title: t.get('ALERT.TITLE.NOTIFICATION'),
                content: t.get('ALERT.CONTENT.SAVE_SUCCESS'),
                type: 'alert-message',
                onAfterClose: onRefCloseDialog,
            })
            dialogTwoRef.current?.openDialog()
        } else {
            setConfigDialog({
                title: t.get('ALERT.TITLE.ERROR'),
                content: t.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
                type: 'alert-message',
                onAfterClose: onRefCloseDialog,
            })
            dialogTwoRef.current?.openDialog()
        }
    }

    const handleClickDisplayPasscode = () => {
        setDisplayPW((prev) => ({ ...prev, passcode: !prev.passcode }))
    }

    const handleClickDisplayConfirmPasscode = () => {
        setDisplayPW((prev) => ({ ...prev, confirmPasscode: !prev.confirmPasscode }))
    }

    return (
        <FinalForm onSubmit={handleSubmitForm} validate={validateForm}>
            {(props: FormRenderProps) => {
                if (onRefFormProps) onRefFormProps(props)
                return (
                    <Grid container spacing={1}>
                        {isPasscode && (
                            <Grid item xs={12}>
                                <MyTextfield
                                    name="passcode"
                                    maxLength={4}
                                    type={displayPW.passcode ? 'text' : 'password'}
                                    materialInputProps={{
                                        disabled: false,
                                        label: `${t.get('UM.PROFILE.PASSCODE')}`,
                                        placeholder: `${t.get('UM.PROFILE.PASSCODE')}`,
                                        size: 'small',
                                    }}
                                    icon={
                                        <IconButton size="small" onClick={handleClickDisplayPasscode}>
                                            {displayPW.passcode ? (
                                                <Visibility style={{ fontSize: '1.2rem' }} />
                                            ) : (
                                                <VisibilityOff style={{ fontSize: '1.2rem' }} />
                                            )}
                                        </IconButton>
                                    }
                                />
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <MyTextfield
                                name="newPasscode"
                                maxLength={4}
                                type={displayPW.confirmPasscode ? 'text' : 'password'}
                                materialInputProps={{
                                    disabled: false,
                                    label: `${t.get('UM.PROFILE.NEW_PASSCODE')}`,
                                    placeholder: `${t.get('UM.PROFILE.NEW_PASSCODE')}`,
                                    size: 'small',
                                }}
                                icon={
                                    <IconButton size="small" onClick={handleClickDisplayConfirmPasscode}>
                                        {displayPW.confirmPasscode ? (
                                            <Visibility style={{ fontSize: '1.2rem' }} />
                                        ) : (
                                            <VisibilityOff style={{ fontSize: '1.2rem' }} />
                                        )}
                                    </IconButton>
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MyTextfield
                                name="confirmNewPasscode"
                                maxLength={4}
                                type={displayPW.confirmPasscode ? 'text' : 'password'}
                                materialInputProps={{
                                    disabled: false,
                                    label: `${t.get('UM.PROFILE.CONFIRM_NEW_PASSCODE')}`,
                                    placeholder: `${t.get('UM.PROFILE.CONFIRM_NEW_PASSCODE')}`,
                                    size: 'small',
                                }}
                                icon={
                                    <IconButton size="small" onClick={handleClickDisplayConfirmPasscode}>
                                        {displayPW.confirmPasscode ? (
                                            <Visibility style={{ fontSize: '1.2rem' }} />
                                        ) : (
                                            <VisibilityOff style={{ fontSize: '1.2rem' }} />
                                        )}
                                    </IconButton>
                                }
                            />
                        </Grid>
                        <Dialog onRef={onRefDialogTwo} {...configDialog} />
                    </Grid>
                )
            }}
        </FinalForm>
    )
}

export default Form
